var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"id":_vm.inputId,"type":_vm.inputType},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('update', $event.target.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }